'use client'

import { Info } from 'lucide-react'
import { EdgeLabelRenderer, EdgeProps, getBezierPath } from 'reactflow'

interface CustomEdgeData {
  tag: string
  description?: string
  condition?: string
  hasMultipleEdges: boolean
  onInfoClick?: () => void
}

export function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
  style,
  markerEnd,
}: EdgeProps<CustomEdgeData>) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  })

  const shouldShowLabel = data?.hasMultipleEdges && data?.tag

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      {shouldShowLabel && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <div className="flex items-center gap-1 rounded border border-gray-200 bg-white/90 px-2 py-1 text-xs font-medium text-gray-600 shadow-sm backdrop-blur-sm">
              <span>{data.tag}</span>
              {data.condition && data.onInfoClick && (
                <button
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    data.onInfoClick!()
                  }}
                  className="flex items-center justify-center rounded-full p-0.5 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
                  title="View condition details"
                >
                  <Info size={12} />
                </button>
              )}
            </div>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  )
}
